import { css } from 'lit';

export const style = css`
  :host {
    display: block;
    margin: 0;
  }

  form {
    margin-bottom: 2em;
  }
`;
